<!-- <div class="p-4 pb-0">
	<app-generic-search-bar />
</div> -->
<div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2 p-2">
	@for (action of actions(); track action.title) {
		<button
			activeDarken
			class="bg-neutral-100 dark:bg-neutral-800 hover-layer rounded-3xl"
			(click)="action.onClick()">
			<app-terminal-action-card [data]="action" />
		</button>
	}
</div>
